import { useTheme } from '@mui/material';

export const MobileFriendlyIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
        >
            <path
                d="M18 10C16.8937 10 16 10.8937 16 12V36C16 37.1063 16.8937 38 18 38H30C31.1063 38 32 37.1063 32 36V12C32 10.8937 31.1063 10 30 10H18ZM14 12C14 9.79375 15.7938 8 18 8H30C32.2062 8 34 9.79375 34 12V36C34 38.2062 32.2062 40 30 40H18C15.7938 40 14 38.2062 14 36V12ZM24 32.5C24.3978 32.5 24.7794 32.658 25.0607 32.9393C25.342 33.2206 25.5 33.6022 25.5 34C25.5 34.3978 25.342 34.7794 25.0607 35.0607C24.7794 35.342 24.3978 35.5 24 35.5C23.6022 35.5 23.2206 35.342 22.9393 35.0607C22.658 34.7794 22.5 34.3978 22.5 34C22.5 33.6022 22.658 33.2206 22.9393 32.9393C23.2206 32.658 23.6022 32.5 24 32.5Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
